import {
  setSuccess,
  setError,
  setIsLoading
} from 'state/meterpoint-validation/meterpoint-validation-slice';
import { validateMeterpoint } from 'api/meterpoint-validation';
import { getErrors } from 'api/client';

export const ErrorMissingMpanAddress = {
  title: 'Sorry, we cannot find your address for your electricity meter.',
  keyword: 'validation'
};

export const ErrorMissingMprnAddress = {
  title: 'Sorry, we cannot find your address for your gas meter.',
  keyword: 'validation'
};

export const ErrorMissingMpanMprnAddress = {
  title: 'Sorry, we cannot find your address',
  keyword: 'validation'
};

export const getMeterpointDetails = (params) => async (dispatch) => {
  const { mpan, mprn } = params;

  try {
    dispatch(setIsLoading());
    const response = await validateMeterpoint(params);
    const { meterpoints } = response;

    const missingMpanAddress =
      !!mpan &&
      !meterpoints?.find(({ fuelType }) => fuelType === 'Electricity');

    const missingMprnAddress =
      !!mprn && !meterpoints?.find(({ fuelType }) => fuelType === 'Gas');

    const missingMpanMprnAddress = missingMpanAddress && missingMprnAddress;
    let errors = [];

    switch (true) {
      case missingMpanMprnAddress:
        errors = [ErrorMissingMpanMprnAddress];
        break;
      case missingMpanAddress:
        errors = [ErrorMissingMpanAddress];
        break;
      case missingMprnAddress:
        errors = [ErrorMissingMprnAddress];
        break;
      default: {
        errors = [];
      }
    }

    const validatedResponse = {
      ...response,
      errors: [...response.errors, ...errors]
    };

    dispatch(setSuccess(validatedResponse));

    return Promise.resolve(validatedResponse);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
